module.exports = __webpack_public_path__ + "static/media/Recomposition_09@2x.ea4b621b.png";